import React from 'react'
import Icons from '../../Icons'
import PropTypes from 'prop-types'
import Spinner from '../../Spinner/Spinner'
import {_L, useLocaleState} from '../../../context/LocaleContext'
import styled from 'styled-components'

export const BUTTON_TYPES = {
  NEXT: 'NEXT',
  BACK: 'BACK',
  CANCEL: 'CANCEL',
  SEND: 'SEND',
  DONE: 'DONE'
}

export const NavigationButtons = ({
  backButtonType,
  nextButtonType,
  onBackClick,
  onNextClick,
  buttonWidth,
  loading
}) => {
  const localeState = useLocaleState()
  const buttonConfiguration = {
    NEXT: {
      label: _L({key: 'Next', localeState}),
      icon: 'NEXT_ARROW'
    },
    BACK: {
      label: _L({key: 'Back', localeState}),
      icon: 'BACK_ARROW'
    },
    CANCEL: {
      label: _L({key: 'Cancel', localeState}),
      icon: 'CANCEL'
    },
    SEND: {
      label: _L({key: 'Send', localeState}),
      icon: 'DONE'
    },
    DONE: {
      label: _L({key: 'Send', localeState}),
      icon: 'DONE'
    }
  }

  const {label: nextLabel, icon: nextIcon} = buttonConfiguration[nextButtonType]
  const {label: backLabel, icon: backIcon} = buttonConfiguration[backButtonType]

  let useFullWidthButton = buttonWidth === 'FULL'

  return (
    <Container>
      {onBackClick && (
        <ButtonContainer useFullWidthButton={useFullWidthButton}>
          <BackButton
            onClick={onBackClick}
            onKeyDown={onBackClick}
            data-testid="navigation-back-button"
          >
            <span style={{marginRight: 10}}>
              <Icons icon={backIcon} />
            </span>
            {backLabel}
          </BackButton>
        </ButtonContainer>
      )}
      <ButtonContainer useFullWidthButton={useFullWidthButton}>
        {loading ? (
          <NextButton data-testid="navigation-next-button">
            <Spinner height="30px" width="30px" />
          </NextButton>
        ) : (
          <NextButton
            onClick={onNextClick}
            onKeyDown={onNextClick}
            data-testid="navigation-next-button"
          >
            {nextLabel}
            <span style={{marginLeft: 10}}>
              <Icons icon={nextIcon} />
            </span>
          </NextButton>
        )}
      </ButtonContainer>
    </Container>
  )
}

NavigationButtons.defaultProps = {
  backButtonType: 'BACK',
  nextButtonType: 'NEXT',
  loading: false,
  buttonWidth: 'FULL'
}

NavigationButtons.propTypes = {
  backButtonType: PropTypes.string.isRequired,
  nextButtonType: PropTypes.string.isRequired
}

const Container = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 0 20px;
  justify-content: space-between;
`
const StyledButton = styled.button`
  width: 100%;
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
  height: 40px;
  border-radius: 6px;
`

const NextButton = styled(StyledButton)`
  background-color: #13294b;
  border: solid 2px #13294b;
  cursor: pointer;
  :focus {
	   border: 5px solid #FF9900;
  }
`

const BackButton = styled(StyledButton)`
  background-color: #646669;
  border: solid 2px #646669;
  cursor: pointer;
  :focus {
	   border: 5px solid #FF9900;
  }
`

const ButtonContainer = styled.div`
  width: ${props => (props.useFullWidthButton ? '100%' : '200px')};
  box-sizing: border-box;
  padding: 4px;
`
